import {IHttpService} from "angular";
import {ConsolidatedOrderDepthRecord} from "../../depth/types/OrderDepthRecord";
import {CodeAndExchange} from "../../instruments/types/CodeAndExchange";

export class ForceLiveDepthService {
    public static id = "forceLiveDepthService";

    /** @ngInject */
    constructor(private $http: IHttpService) {
    }

    public async load(security: CodeAndExchange): Promise<ConsolidatedOrderDepthRecord> {
        const url = `/tradefloor/api/price-depth/${security.code}/${security.exchange}`;
        const config = {
            method: "GET",
            url,
            headers: {"x-live-quote": true},
            ignoreLoadingBar: true
        };
        const response = await this.$http<ConsolidatedOrderDepthRecord>(config)
        return response.data!;
    }
}
